"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
const fetchOutputKeys_1 = require("../helper/fetchOutputKeys");
const utils_1 = require("../helper/utils");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
class ResourceNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.RESOURCE };
    if (props.type !== types_1.NODE_TYPES.RESOURCE)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializeData = {
      service: "",
      method: "",
      params: null,
      addOns: []
    };
    if (!nodeData) return deserializeData;
    deserializeData = {
      service: nodeData.service,
      method: nodeData.method,
      params: { paramsValue: nodeData.params, error: false },
      addOns: nodeData.addOns
    };
    return deserializeData;
  }
  serialize(uiData) {
    let data = {
      service: uiData.service,
      method: uiData.method,
      params: uiData.params ? uiData.params.paramsValue : {},
      addOns: uiData.addOns
    };
    // modify if required
    return data;
  }
  getAttachedApis(selectedResource) {
    let data = this.getNodeData();
    if (!data) return [];
    let { service, method, addOns } = data;
    let apis = [{ service, method, type: types_1.AwsApiType.Primary }];
    for (const addOn of addOns) {
      apis.push({
        service: addOn.service,
        method: addOn.method,
        type: types_1.AwsApiType.AddOn
      });
    }
    if (selectedResource.path) {
      return apis.filter(x =>
        selectedResource.path.includes(utils_1.getPrettyName(x.method))
      );
    }
    return apis;
  }
  getResourcesForSelectedMethod() {
    let resources = [];
    let data = this.getNodeData();
    if (!data) return [];
    let { method } = data;
    let prettyName = utils_1.getPrettyName(method);
    resources.push({
      nodeRef: this,
      label: [this.getNodeName(), prettyName].join(".").replace(" ", ""),
      selectedResourceId: this.id,
      path: "",
      context: {
        outputPath: ""
      }
    });
    return resources;
  }
  getResourcesForSelectedAddOns() {
    let resources = [];
    let data = this.getNodeData();
    if (!data) return [];
    let { addOns } = data;
    let resourcePrettyName = utils_1.getPrettyName(data.method);
    for (let addOn of addOns) {
      let { method } = addOn;
      let addOnPrettyName = utils_1.getPrettyName(method);
      let addOnLabel = [
        this.getNodeName(),
        resourcePrettyName,
        "addOns",
        addOnPrettyName
      ]
        .join(".")
        .replace(" ", "");
      resources.push({
        nodeRef: this,
        label: addOnLabel,
        selectedResourceId: this.id,
        path: ["addOns", addOnPrettyName, "data"].join("."),
        context: {
          outputPath: `addOns.${addOnPrettyName}.data`
        }
      });
    }
    return resources;
  }
  async getAvailableResources() {
    let resources = [];
    resources = resources.concat(this.getResourcesForSelectedMethod());
    resources = resources.concat(this.getResourcesForSelectedAddOns());
    return resources;
  }
  // complete type
  async getOutputKeys(params) {
    let nodeData = params.data || this.getNodeData();
    if (!nodeData || !nodeData.service || !nodeData.method) return [];
    let { service, method, addOns } = nodeData;
    let outputKeys = await fetchOutputKeys_1.fetchOutputKeys(
      this.getDataResolver(),
      service,
      method
    );
    for (const addOn of addOns) {
      const addOnOutputKeys = await fetchOutputKeys_1.fetchOutputKeys(
        this.getDataResolver(),
        addOn.service,
        addOn.method
      );
      let modified = addOnOutputKeys.map(({ name, value }) => {
        let fieldName = utils_1.getPrettyName(addOn.method).replace(" ", "");
        return {
          name: `${fieldName}.${name}`,
          value: `addOns.${fieldName}.data..${value}`
        };
      });
      outputKeys = outputKeys.concat(modified);
    }
    if (
      !params.resource ||
      !params.resource.context ||
      !params.resource.context.outputPath
    )
      return outputKeys;
    return this.getKeysForPath(params.resource.context.outputPath, outputKeys);
  }
  validate() {
    return new validations_1.ResourceNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  getCloudProvider() {
    return cloudProvider_1.default.AWS;
  }
}
exports.ResourceNode = ResourceNode;
//# sourceMappingURL=ResourceNode.js.map
